import { Link } from 'react-router-dom';

interface Props {
  userName: string;
  email: string;
  avatar?: string;
  mobile?: string;
  availableAmount?: number;
  coursesCount: number;
  ordersCount: number;
  member?: boolean;
  memberPlanName?: string;
  memberExpireTime?: string;
}

const AccountHeader = ({ userName, email, avatar, mobile, availableAmount, coursesCount, ordersCount, member, memberPlanName, memberExpireTime }: Props) => {
  return (
    <div className="bg-[radial-gradient(circle_at_left_top,_#133b70_0%,_#0a1628_48%,_#0b1220_100%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
        <div className="rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-sm px-5 py-5 sm:px-7 sm:py-6 flex flex-col sm:flex-row items-start sm:items-center gap-5 shadow-[0_28px_55px_-40px_rgba(15,23,42,0.8)]">
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden bg-violet-500/20 flex items-center justify-center text-white text-2xl font-bold">
            {avatar ? <img src={avatar} alt={userName} className="w-full h-full object-cover" /> : userName.slice(0, 1).toUpperCase()}
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2 mb-1">
              <h1 className="text-xl sm:text-2xl font-bold text-white">{userName}</h1>
              <span className={`px-2.5 py-0.5 border text-[11px] font-semibold rounded-full whitespace-nowrap ${
                member
                  ? 'bg-emerald-500/20 border-emerald-400/30 text-emerald-200'
                  : 'bg-violet-500/20 border-violet-400/30 text-violet-300'
              }`}>
                {member ? memberPlanName || '會員有效' : '普通學員'}
              </span>
            </div>
            <p className="text-slate-300 text-sm mb-2">{email}</p>
            <p className="text-slate-400 text-xs mb-3">{mobile || '未绑定手机号'}</p>
            {member && memberExpireTime ? (
              <p className="mb-3 text-xs text-emerald-300">有效至 {memberExpireTime}</p>
            ) : null}
            <div className="flex flex-wrap items-center gap-4 sm:gap-6">
              <div className="flex items-center gap-2">
                <i className="ri-book-open-line text-violet-400 text-sm" />
                <span className="text-white font-bold text-sm">{coursesCount}</span>
                <span className="text-slate-500 text-xs">已購課程</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-receipt-line text-amber-400 text-sm" />
                <span className="text-white font-bold text-sm">{ordersCount}</span>
                <span className="text-slate-500 text-xs">訂單記錄</span>
              </div>
              {Number(availableAmount || 0) > 0 ? (
                <div className="flex items-center gap-2">
                  <i className="ri-wallet-3-line text-cyan-300 text-sm" />
                  <span className="text-white font-bold text-sm">${Number(availableAmount || 0).toFixed(2)}</span>
                  <span className="text-slate-500 text-xs">可用餘額</span>
                </div>
              ) : null}
            </div>
          </div>

          <Link
            to="/contact?tab=student"
            className="flex-shrink-0 flex items-center gap-1.5 px-4 py-2 bg-white/10 hover:bg-white/20 text-white text-xs font-semibold rounded-lg cursor-pointer transition-all whitespace-nowrap border border-white/15"
          >
            <i className="ri-customer-service-2-line text-sm" />
            聯絡支援
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccountHeader;
